export const dataSection_1 = [
  ["MRS-2.7-C-8.0-TI-SC", "MRS-2.7-C-10.0-TI-SC", "MRS-2.7-C-12.0-TI-SC", "MRS-2.7-C-14.0-TI-SC", "MRS-2.7-C-16.0-TI-SC", "MRS-2.7-C-18.0-TI-SC", "MRS-2.7-C-20.0-TI-SC"],
  [" Ø2.7 x 8 mm.", " Ø2.7 x 10 mm.", " Ø2.7 x 12 mm.", " Ø2.7 x 14 mm.", " Ø2.7 x 16 mm.", " Ø2.7 x 18 mm.", " Ø2.7 x 20 mm."]
]
export const dataSection_2 = [
  ["MRS-3.0-EC-10.0-TI-SC","MRS-3.0-EC-12.0-TI-SC","MRS-3.0-EC-14.0-TI-SC"],
  [" Ø3.0 x 10 mm. "," Ø3.0 x 12 mm. "," Ø3.0 x 14 mm. "]
]